import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles()((theme) => ({
	wave: {
		width: '100%',
		display: 'block',
		color: theme.palette.neutral[5],
	},
	flipped: {
		rotate: '180deg',
	},
}));
